import { type CSSProperties } from 'react';
import { useRelativeTime } from '../hooks/useRelativeTime';

interface RelativeTimeProps {
  value: string | null | undefined;
  className?: string;
  style?: CSSProperties;
}

export default function RelativeTime({ value, className, style }: RelativeTimeProps) {
  const label = useRelativeTime(value);
  if (!label) return null;

  return (
    <span className={className} style={style} title={label.absolute}>
      {label.relative}
    </span>
  );
}
